import semver from 'semver'

export const MAX_MINOR_BOT_VERSION = 999

// TODO: the name "version.ts" conflicts with historic "Version.ts" - you can rename this file to "version.ts"
// in the future (circa 1/2026), right now there are too many competing builds with "version" and "Version" in pipeline.

export function areGivenVersionsEqual(version1: string, version2: string): boolean {
  return Boolean(semver.valid(version1) && semver.valid(version2) && semver.eq(version1, version2))
}

export function isFeatureBranch(value: string): boolean {
  return value.startsWith('feature/')
}

export function versionExceedsMaxMinorVersionForBot(version?: string): boolean {
  return !!version && Number(version.split('.')[1]) > MAX_MINOR_BOT_VERSION
}
